<template>
  <div class="col-12 p-0 h-100 position-relative iframe-component overflow-auto">
    <component v-bind:is="component_name" />
    <!-- <div class="position-absolute iframe-userinfo">
      <userInfo />
    </div> -->
  </div>
</template>

<script>
// import { mapActions, mapGetters } from "vuex";
import Sector_valuation from "../Valuation/Sector_Valuations.vue";
import Ethanol_RBOB from "../Sector/Ethanol_RBOB.vue";
import Reinvestment from "../Sector/Reinvestment.vue";
import RecessionRisks from "../Macro/recessionriskstilllimitednearterm/RecessionRisks.vue";
import Probability_Based_On_CFNAI from "../Macro/recessionriskstilllimitednearterm/Probability_Based_On_CFNAI.vue";
import Probability_Based_On_Yield_Curve from "../Macro/recessionriskstilllimitednearterm/Probability_Based_On_Yield_Curve.vue";
import Recession_Criteria_Change_vs_End_Of_Last_Recession from "../Macro/recessionriskstilllimitednearterm/Recession_Criteria_Change_vs_End_Of_Last_Recession.vue";
import Ratio_Conincident_Lagging from "../Macro/recessionriskstilllimitednearterm/Ratio_Conincident_Lagging.vue";
import LeadingIndicators from "../Macro/leadingindicator/LeadingIndicators.vue";
import OECD_leading_indicators_Global_US_and_Europe from "../Macro/leadingindicator/OECD_leading_indicators_Global_US_and_Europe.vue";
import OECD_leading_indicators_China_Japan_Brazil from "../Macro/leadingindicator/OECD_leading_indicators_China_Japan_Brazil.vue";
import US_leading_indicator_3mo_6mo_12mo_change from "../Macro/leadingindicator/US_leading_indicator_3mo_6mo_12mo_change.vue";
import China_leading_indicator_3mo_6mo_12mo_change from "../Macro/leadingindicator/China_leading_indicator_3mo_6mo_12mo_change.vue";
import USIndustrialProduction from "../Macro/usindustrialproduction/USIndustrialProduction.vue";
import IP_Index_YoY from "../Macro/usindustrialproduction/IP_Index_YoY.vue";
import ISM_vs_WTI_Oil_YoY from "../Macro/usindustrialproduction/ISM_vs_WTI_Oil_YoY.vue";
import Traded_weighted from "../Macro/usindustrialproduction/Traded_weighted.vue";
import US_IP_CAGR from "../Macro/usindustrialproduction/US_IP_CAGR.vue";
import GDP from "../Macro/gdp/gdp.vue";
import EU_GDP_Forecast from "../Macro/gdp/EU_GDP_Forecast.vue";
import Belgian_Industrial_Confidence_vs_ECB_lendingEasing from "../Macro/gdp/Belgian_Industrial_Confidence_vs_ECB_lendingEasing.vue";
import ECB_Money_Supply from "../Macro/gdp/ECB_Money_Supply.vue";
import EU_Chemicals_IP_vs_EU_Industrial_Confidence from "../Macro/gdp/EU_Chemicals_IP_vs_EU_Industrial_Confidence.vue";
import Inventory from "../Macro/inventory/inventory.vue";
import Impact_Of_10_Swing_In_Consumer_Demand_On_Suppliers from "../Macro/inventory/ImpactOfSwingIncunsumerDemandonsuppliers.vue";
import ISM_Inventories_Survey from "../Macro/inventory/ISM_Inventories_Survey.vue";
import Final_sales_vs_inventories from "../Macro/inventory/Final_sales_vs_inventories.vue";
import Chemical_Sector_Pricing_Power from "../Macro/inventory/Chemical_Sector_Pricing_Power.vue";
import ConsumerSpending from "../Macro/consumerspending/ConsumerSpending.vue";
import PCE_Forecast from "../Macro/consumerspending/PCE_Forecast.vue";
import Real_GDP_Forecast from "../Macro/consumerspending/Real_GDP_Forecast.vue";
import Fed_Fund_Rate_Consumer_Spending from "../Macro/consumerspending/Fed_Fund_Rate_Consumer_Spending.vue";
import Durable_Investment from "../Macro/consumerspending/Durable_Investment.vue";
import USConstruction from "../Macro/usconstruction/USConstruction.vue";
import Residential_Nonresidential_construction from "../Macro/usconstruction/Residential_Nonresidential_construction.vue";
import New_Family_Homes from "../Macro/usconstruction/New_Family_Homes.vue";
import US_Construction_Spending from "../Macro/usconstruction/US_Construction_Spending.vue";
import NAHB_Leads_Final_Sales_Housing_Start from "../Macro/usconstruction/NAHB_Leads_Final_Sales_Housing_Start.vue";
import InflationHardertopace from "../Macro/inflationhardertopace/InflationHardertopace.vue";
import PPI_Intermediate_Goods from "../Macro/inflationhardertopace/PPI_Intermediate_Goods.vue";
import PPI_Finished_goods from "../Macro/inflationhardertopace/PPI_Finished_goods.vue";
import Govt_Outlays from "../Macro/inflationhardertopace/Govt_Outlays.vue";
import Inflation from "../Macro/inflation/Inflation.vue";
import US_CPI from "../Macro/inflation/US_CPI.vue";
import Brent_vs_Natural_Gas from "../Macro/inflation/Brent_vs_Natural_Gas.vue";
import CPI_vs_PPI from "../Macro/inflation/CPI_vs_PPI.vue";
import Chemical_sector_pricing from "../Macro/inflation/Chemical_sector_pricing.vue";
import CapitalSpending from "../Macro/capitalspending/CapitalSpending.vue";
// import Real_Retail_Sales from "../Macro/Real_Retail_Sales.vue";
// import Effective_Tax_Rate from "../Macro/Effective_Tax_Rate.vue";
import Capex_YoY from "../Macro/capitalspending/Capex_YoY.vue";
import Fed_Cap_Index from "../Macro/capitalspending/Fed_Cap_Index.vue";
import Capex_Cycle from "../Macro/capitalspending/Capex_Cycle.vue";
import Chemical_sector_capex from "../Macro/capitalspending/Chemical_sector_capex.vue";
import Corn from "../Macro/corn/Corn.vue";
import Corn_YoY from "../Macro/corn/Corn_YoY.vue";
import Corn_Profit_Margins from "../Macro/corn/Corn_Profit_Margins.vue";
import Corn_Yield from "../Macro/corn/Corn_Yield.vue";
import NetDebtEditda from "../Macro/netdebteditda/NetDebtEditda.vue";
import Rolling_Net_Debt_EBITDA from "../Macro/netdebteditda/Rolling_Net_Debt_EBITDA.vue";
import Deleveraging from "../Macro/netdebteditda/Deleveraging.vue";
import RegionalTrends from "../Macro/regionaltrends/RegionalTrends.vue";
import CPI_and_Sentiments from "../Macro/regionaltrends/CPI_and_Sentiments.vue";
import GDP_Treasury_yield from "../Macro/regionaltrends/GDP_Treasury_yield.vue";
import Risk_spread from "../Macro/regionaltrends/Risk_spread.vue";
import Mean_Reversion from "../Stock/Mean_Reversion.vue";
import Waterfall from "../Waterfall/index.vue";
import Sales from "../Waterfall/Sales.vue";
import EBITDA from "../Waterfall/EBITDA.vue";
export default {
  name: "Iframe_Component_Wrapper",
  components: {
    // userInfo,
    sectorvaluations: Sector_valuation,
    ethanolrcb: Ethanol_RBOB,
    reinvestment: Reinvestment,
    
    recessionRisks: RecessionRisks,

    probabilitybasedoncfnai: Probability_Based_On_CFNAI,
    probabilitybasedonyieldcurve: Probability_Based_On_Yield_Curve,
    recessioncriteriachangevsendoflastrecession: Recession_Criteria_Change_vs_End_Of_Last_Recession,
    ratioconincidentlaggingleiyoyvsrecessiontiming: Ratio_Conincident_Lagging,
    
    leadingindicator: LeadingIndicators,

    oecdleadingindicatorsglobalusandeurope: OECD_leading_indicators_Global_US_and_Europe,
    oecdleadingindicatorschinajapanbrazil: OECD_leading_indicators_China_Japan_Brazil,
    usleadingindicator3mo6mo12mochange: US_leading_indicator_3mo_6mo_12mo_change,
    chinaleadingindicator3mo6mo12mochange: China_leading_indicator_3mo_6mo_12mo_change,
    
    usindustrialproduction: USIndustrialProduction,
    
    ipindexyoy: IP_Index_YoY,
    ismvswtioilyoy: ISM_vs_WTI_Oil_YoY,
    tradedweighted: Traded_weighted,
    usipcagr: US_IP_CAGR,

    gdp: GDP,

    eugdpforecast: EU_GDP_Forecast,
    belgianindustrialconfidencevsecblendingeasing: Belgian_Industrial_Confidence_vs_ECB_lendingEasing,
    ecbmoneysupply: ECB_Money_Supply,
    euchemicalsipvseuindustrialconfidence: EU_Chemicals_IP_vs_EU_Industrial_Confidence,
    
    inventory: Inventory,
    
    impactofswingincunsumerdemandonsuppliers: Impact_Of_10_Swing_In_Consumer_Demand_On_Suppliers,
    isminventoriessurvey: ISM_Inventories_Survey,
    finalsalesvsinventories: Final_sales_vs_inventories,
    chemicalsectorpricingpower: Chemical_Sector_Pricing_Power,

    consumerspending: ConsumerSpending,
    
    pceforecast: PCE_Forecast,
    realgdpforecast: Real_GDP_Forecast,
    fedfundrateconsumerspending: Fed_Fund_Rate_Consumer_Spending,
    durableinvestment: Durable_Investment,

    usconstruction: USConstruction,
    
    residentialnonresidentialconstruction: Residential_Nonresidential_construction,
    newfamilyhomes: New_Family_Homes,
    usconstructionspending: US_Construction_Spending,
    nahbleadsfinalsaleshousingstart: NAHB_Leads_Final_Sales_Housing_Start,

    inflationhardertopace: InflationHardertopace,

    ppiintermediategoods: PPI_Intermediate_Goods,
    ppifinishedgoods: PPI_Finished_goods,
    govtoutlays: Govt_Outlays,

    inflation: Inflation,

    uscpi: US_CPI,
    brentvsnaturalgas: Brent_vs_Natural_Gas,
    cpivsppi: CPI_vs_PPI,
    chemicalsectorpricing: Chemical_sector_pricing,

    capitalspending: CapitalSpending,

    // : Real_Retail_Sales,
    // : Effective_Tax_Rate,
    capexyoy: Capex_YoY,
    fedcapindex: Fed_Cap_Index,
    capexcycle: Capex_Cycle,
    chemicalsectorcapex: Chemical_sector_capex,
    
    corn: Corn,

    cornyoy: Corn_YoY,
    cornprofitmargins: Corn_Profit_Margins,
    cornyield: Corn_Yield,

    netdebteditda: NetDebtEditda,

    rollingnetdebtebitda: Rolling_Net_Debt_EBITDA,
    deleveraging: Deleveraging,
    
    regionaltrends: RegionalTrends,
    cpiandsentiments: CPI_and_Sentiments,
    gdptreauryyield: GDP_Treasury_yield,
    riskspread: Risk_spread,

    meanreversion: Mean_Reversion,

    waterfall: Waterfall,
    
    sales: Sales,
    ebitda: EBITDA,
  },
  data() {
    return {
      component_name: "sector_valuations",
      //   component_list: [],
    };
  },
  computed: {},
  methods: {},
  beforeMount() {
    // let list = [
    //   {
    //     chartId: 179,
    //     component_name: "sector_valuations",
    //   },
    //   {
    //     chartId: 180,
    //     component_name: "RecessionRisks",
    //   },
    // ];
    // this.component_list = list;
    if (window.location.href.includes("auth_token=")) {
      let params = this.$router.currentRoute.params;
      let chart_component_name = params.chart_component_name;
      // chart_component_name = chart_component_name.replace("_", " ");
      this.component_name = chart_component_name;
      // console.log("chart_component_name", chart_component_name);
    }
  },
  mounted() {},
};
</script>

<style>
.iframe-component .scroll50Panel {
  height: calc(100vh - 100px);
}
.iframe-component .iframe-userinfo {
  width: calc(100vw - 10px);
  height: 0px;
}
</style>
